/* assets/eclora-ws.js — page produit Éclora Shift Socks.
   Galerie (défilement + vignettes), choix de variante, fenêtre du guide des tailles, carrousel de témoignages.
   Aucune dépendance. Tout se ré-initialise sur shopify:section:load. */
(function () {
  'use strict';
  if (window.__ewsLoaded) return;
  window.__ewsLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';

  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  /* ----- Galerie ----- */
  function initGallery(gallery) {
    if (gallery.dataset.ewsReady) return;
    gallery.dataset.ewsReady = '1';
    var track = gallery.querySelector('[data-ews-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-ews-slide]');
    var thumbs = gallery.querySelectorAll('[data-ews-thumb]');
    var prev = gallery.querySelector('[data-ews-prev]');
    var next = gallery.querySelector('[data-ews-next]');
    var index = 0;

    function setCurrent(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      Array.prototype.forEach.call(thumbs, function (t, n) { t.setAttribute('aria-current', n === index ? 'true' : 'false'); });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      var active = thumbs[index];
      if (active && active.parentNode && active.parentNode.parentNode) {
        var list = active.parentNode.parentNode;
        var li = active.parentNode;
        var left = li.offsetLeft - list.offsetLeft;
        if (left < list.scrollLeft || left + li.offsetWidth > list.scrollLeft + list.clientWidth) {
          list.scrollTo({ left: left - (list.clientWidth - li.offsetWidth) / 2, behavior: behavior });
        }
      }
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: behavior });
      setCurrent(i);
    }
    gallery.ewsGoToValue = function (values) {
      var done = false;
      Array.prototype.forEach.call(slides, function (s, n) {
        if (!done && s.dataset.ewsOptionValue && values.indexOf(s.dataset.ewsOptionValue) !== -1) { goTo(n); done = true; }
      });
    };
    gallery.ewsGoToMedia = function (mediaId) {
      Array.prototype.forEach.call(slides, function (s, n) { if (String(s.dataset.mediaId) === String(mediaId)) goTo(n); });
    };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        setCurrent(Math.round(track.scrollLeft / w));
      });
    }, { passive: true });
    Array.prototype.forEach.call(thumbs, function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    setCurrent(0);
  }

  /* ----- Variantes ----- */
  function initVariants(main) {
    var box = main.querySelector('[data-ews-options]');
    var dataEl = main.querySelector('[data-ews-variants]');
    if (!box || !dataEl || box.dataset.ewsReady) return;
    box.dataset.ewsReady = '1';
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = main.querySelector('[data-ews-variant-id]');
    var atc = main.querySelector('[data-ews-atc]');
    var atcText = main.querySelector('[data-ews-atc-text]');
    var price = main.querySelector('[data-ews-price]');
    var compare = main.querySelector('[data-ews-compare]');
    var gallery = main.querySelector('[data-ews-gallery]');
    var groups = box.querySelectorAll('[data-ews-option]');

    function selected() {
      return Array.prototype.map.call(groups, function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (variants[i].options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function markAvailability(opts) {
      Array.prototype.forEach.call(groups, function (g, gi) {
        each(g, 'input', function (input) {
          var test = opts.slice();
          test[gi] = input.value;
          var v = find(test);
          var label = input.closest('label');
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update(fromUser, changedValue) {
      var opts = selected();
      var v = find(opts);
      markAvailability(opts);
      if (!v) { if (atc) atc.disabled = true; return; }
      if (idInput && String(idInput.value) !== String(v.id)) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? atc.dataset.label : atc.dataset.soldOut;
      }
      if (price) price.textContent = v.price;
      if (compare) { compare.hidden = !v.compare; if (v.compare) compare.textContent = v.compare; }
      if (fromUser) {
        if (v.media && gallery && gallery.ewsGoToMedia) gallery.ewsGoToMedia(v.media);
        else if (changedValue && gallery && gallery.ewsGoToValue) gallery.ewsGoToValue([changedValue]);
        if (window.history && window.history.replaceState && !(window.Shopify && window.Shopify.designMode)) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }
    box.addEventListener('change', function (e) { update(true, e.target && e.target.value); });
    update(false);
  }

  /* ----- Fenêtre (guide des tailles) ----- */
  function initDialogs(root) {
    each(root, '[data-ews-dialog-open]', function (btn) {
      if (btn.dataset.ewsReady) return;
      btn.dataset.ewsReady = '1';
      var dialog = document.getElementById(btn.getAttribute('data-ews-dialog-open'));
      if (!dialog) return;
      btn.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-ews-dialog-close]')) {
          if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
        }
      });
    });
  }

  /* ----- Carrousel de témoignages ----- */
  function initCarousel(el) {
    if (el.dataset.ewsReady) return;
    el.dataset.ewsReady = '1';
    var track = el.querySelector('[data-ews-carousel-track]');
    var prev = el.querySelector('[data-ews-carousel-prev]');
    var next = el.querySelector('[data-ews-carousel-next]');
    if (!track) return;
    function step() { var first = track.children[0]; return first ? first.offsetWidth + 12 : track.clientWidth; }
    function sync() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  /* ----- Compte à rebours de la barre d'annonce : vise chaque jour l'heure de fin réglée (heure du visiteur) ----- */
  function initCountdown(el) {
    if (el.dataset.ewsReady) return;
    el.dataset.ewsReady = '1';
    var endHour = parseInt(el.getAttribute('data-end-hour'), 10);
    if (isNaN(endHour)) endHour = 23;
    var h = el.querySelector('[data-unit="hours"]');
    var m = el.querySelector('[data-unit="minutes"]');
    var s = el.querySelector('[data-unit="seconds"]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      if (!document.body.contains(el)) { window.clearInterval(timer); return; }
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endHour, 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var left = Math.floor((end - now) / 1000);
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
      if (s) s.textContent = pad(left % 60);
    }
    var timer = window.setInterval(tick, 1000);
    tick();
  }

  function initAll(root) {
    root = root || document;
    each(root, '[data-ews-countdown]', initCountdown);
    each(root, '[data-ews-gallery]', initGallery);
    each(root, '[data-ews-main]', initVariants);
    initDialogs(root);
    each(root, '[data-ews-carousel]', initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-ews-slide]');
    if (slide && slide.parentNode) slide.parentNode.scrollTo({ left: slide.offsetLeft - slide.parentNode.offsetLeft, behavior: 'auto' });
    var acc = e.target.closest && e.target.closest('.ews-acc');
    if (acc) acc.open = true;
  });
})();
